import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Table, Icon, Popup, Label, Image } from 'semantic-ui-react';
import { getAuthorisedIcon } from '../../components/social-table';
import TelegramChannelsTable from './telegram-channels';
import { FacebookIcon, TwitterIcon, InstagramIcon, YoutubeIcon, TiktokIcon, TwitchIcon } from '../dyzio-icons';
import { scientificFormat } from '../../utils/helpers/formatting';

const tableStyle = {
  fontSize: 12,
};

const redbackgroundStyle = {
  background: 'rgb(239,58,80, .2)',
};

const getYoutubeLink = handle => {
  if (!handle) return '';
  const channelIdRegex = /^UC([a-zA-Z0-9_-]{22})$/;
  return handle.match(channelIdRegex) ? 'channel/' : 'user/';
};

const Username = ({
  handle,
  handleLength,
}) => {
  const maxLength = handleLength || 13;
  const isBigUsername = _.size(handle) > maxLength;
  if (isBigUsername) {
    return (
      <Popup
        content={handle} trigger={
          <span>{_.truncate(handle, { length: maxLength }) || '-'}</span>
        }
      />
    );
  }
  return <span>{handle}</span>;
};

const SocialExternalLink = ({
  platform,
  handle,
  influencer,
}) => {
  const isYoutube = platform === 'youtube';
  const youtubePath = isYoutube ? `/channel/${influencer.youtubeChannelId ||
    influencer.youtubeChannelTitle ||
    influencer.youtube}` : '';
  const isTiktok = platform === 'tiktok';
  const tiktokNotation = isTiktok ? '@' : '';
  return (
    <a
      href={`https://www.${platform}.com/${youtubePath}${tiktokNotation}${isYoutube ? '' : handle}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Username handle={handle} />
    </a>);
};

const SocialChannelInfo = props => {
  const { isBusinessAccount, icon, platform, username, count, influencer, isFacebookPersonalPage } = props;
  const isFacebook = platform === 'facebook';
  console.log(influencer);
  console.log(influencer.telegramChannels);
  if (!username) return null;
  return (
    <Table.Row style={isFacebook && isFacebookPersonalPage ? redbackgroundStyle : {}}>
      <Table.Cell>
        {
          isBusinessAccount ?
            <Popup
              trigger={
                <Icon.Group size="large">
                  <Icon name="instagram" color="pink" />
                  <Icon corner name="briefcase" color="pink" />
                </Icon.Group>
              }
              content="Business Account"
            />
            :
            icon
        }
      </Table.Cell>
      <Table.Cell>
        <SocialExternalLink handle={username} platform={platform} influencer={influencer} />
      </Table.Cell>
      <Table.Cell>
        {scientificFormat(count) || '-'}
      </Table.Cell>
      <Table.Cell>
        {!isFacebookPersonalPage && getAuthorisedIcon(influencer, platform)}
        {
          isFacebook && isFacebookPersonalPage &&
          <Popup
            content="This is a personal page. This instagram account must be linked to a Community page."
            trigger={
              <Icon
                size="small"
                className="circular"
                color="red"
                name="warning"
                inverted
              />
            }
          />
        }
      </Table.Cell>
    </Table.Row>
  );
};

const hasTelegramChannels = telegramChannelsArray => !_.isEmpty(telegramChannelsArray);

const InfluencerSocialChannelsTable = influencer => (
  <div>
    <Table
      style={tableStyle}
      stackable
      basic="very"
      textAlign="center"
      verticalAlign="middle"
    >
      <Table.Body>
        <SocialChannelInfo
          influencer={influencer}
          isAuthorised={influencer.instagramAuthorised}
          username={influencer.instagram}
          platform="instagram"
          count={influencer.instagramCount}
          icon={<InstagramIcon size="large" />}
          instagramBusinessAccount={influencer.instagramBusinessAccount}
        />
        <SocialChannelInfo
          influencer={influencer}
          isAuthorised={influencer.facebookAuthorised}
          username={influencer.facebook}
          platform="facebook"
          isFacebookPersonalPage={influencer.isFacebookPersonalPage}
          count={influencer.facebookCount}
          icon={<FacebookIcon size="large" />}
        />
        <SocialChannelInfo
          influencer={influencer}
          isAuthorised={influencer.twitterAuthorised}
          username={influencer.twitter}
          platform="twitter"
          count={influencer.twitterCount}
          icon={<TwitterIcon size="large" />}
        />
        <SocialChannelInfo
          influencer={influencer}
          isAuthorised={influencer.youtubeAuthorised}
          username={influencer.youtubeChannelTitle || influencer.youtube}
          count={influencer.youtubeCount}
          platform="youtube"
          icon={<Label>YOUTUBE</Label>}
        />
        <SocialChannelInfo
          influencer={influencer}
          username={influencer.tiktok}
          count={influencer.tiktokCount}
          platform="tiktok"
          icon={<TiktokIcon size="large" />}
        />
        <SocialChannelInfo
          influencer={influencer}
          username={influencer.twitch}
          count={influencer.twitchCount}
          platform="twitch"
          icon={<TwitchIcon size="large" />}
        />
      </Table.Body>
    </Table>
    {
      hasTelegramChannels(influencer.telegramChannels) &&
      <TelegramChannelsTable {...influencer} />
    }
  </div>
);

SocialChannelInfo.propTypes = {
  isBusinessAccount: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  username: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

SocialChannelInfo.defaultProps = {
  isBusinessAccount: false,
};

export default InfluencerSocialChannelsTable;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-social-channels-table/index.js
 **/